<!-- VendorDetailsHeader.vue -->

<template>

  <div v-if="!isFetching('fetchingVendor')">
    <div class="d-flex mb-3 border-bottom align-items-end">
      <div class="col-4 d-flex align-items-end">
        <div class="p-2 ps-0">
          <div class="fs-3 mb-0 fw-semibold"><i class="bi bi-person-workspace"></i> {{ record.fields['Full Name'] }}</div>
        </div>
      </div>

      <!-- Stats: Total Billed -->
      <template v-if="!isPublicMode">
        <div v-if="mixinUserInRoles(['Admin'])" class="col-2 text-end ms-auto">
          <div class="p-2">
            <p class="mb-0 text-muted">Total Jobs Billed in Euro</p>
            <div class="fs-5 mb-0 fw-semibold">€{{ mixinFormatNumber(record.fields['Total Billed in €']) }}</div>
          </div>
        </div>

        <!-- Stats: Total Costs -->
        <div v-if="mixinUserInRoles(['Admin'])" class="col-2 text-end">
          <div class="p-2">
            <p class="mb-0 text-muted">Vendor Costs in Euro</p>
            <div class="fs-5 mb-0 fw-semibold">€{{ mixinFormatNumber(record.fields['Total Costs in €']) }}</div>
          </div>
        </div>

        <!-- Stats: Profit -->
        <div v-if="mixinUserInRoles(['Admin'])" class="col-2 text-end">
          <div class="p-2">
            <p class="mb-0 text-muted">Profit in Euro</p>
            <div class="fs-5 mb-0 fw-semibold">€{{ mixinFormatNumber(record.fields['Profit']) }}</div>
          </div>
        </div>

        <!-- Stats: Profit Margin -->
        <div v-if="mixinUserInRoles(['Admin'])" class="col-2 text-end">
          <div class="p-2">
            <p class="mb-0 text-muted">Profit Margin</p>
            <div class="fs-5 mb-0 fw-semibold" :class="mixinGetPercentageClass(record.fields['Margin'])">{{ mixinFormatMargin(record.fields['Margin']) }}</div>
          </div>
        </div>
      </template>
    </div>
  </div>

</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'VendorDetailsHeader',
  emits: [
    'showAlert',
    'showError',
  ],
  props: {
    record: {
      type: Object,
      required: true,
    },

    isPublicMode: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return { };
  },

  computed: {
    ...mapGetters([
      'isCreating',
      'isFetching',
      'isUpdating',
      'isDeleting',

      'getProperty',
    ]),
  },

  watch: { },

  methods: { },

  created() { },
};
</script>